import { memo, useMemo } from 'react';
import styled, { type CSSObject } from '@emotion/styled';

import type { ThemeProps } from '@emotion/react';

import { cleanUserInput } from '../../lib/cleanUserInput';
import { quillAlignment } from '../../lib/quillAlignment';
import { themeFont } from '../../lib/themeFont';

import type { Wws_ParagraphItem } from '../../types/graphql';

export const P = styled('div')`
  word-break: break-word;
  padding: 0;
  margin: 1.1em auto;
  max-width: 550px;
  text-align: left;
  width: 100%;

  ${themeFont('s6')}

  @media (min-width: 720px) {
    max-width: 720px;
  }

  @media (max-width: 768px) {
    padding: 0 16px;
  }

  strong {
    font-weight: bolder !important;
  }

  em {
    font-style: italic !important;
  }

  a {
    text-decoration: underline;
    ${(props: ThemeProps): CSSObject | undefined =>
      props.theme.components.Link};
  }

  ${quillAlignment}
`;

export interface ParagraphItemProps {
  item: Wws_ParagraphItem;
  className?: string | undefined;
}

function ParagraphItem({ item, className }: ParagraphItemProps) {
  const { content, id } = item;

  const dangerouslySetInnerHTML = useMemo<{
    __html: string;
  }>(() => ({ __html: cleanUserInput(content) }), [content]);

  return (
    <P
      className={className}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
      data-testid={`paragraph-item-${id}`}
    />
  );
}

export default memo(ParagraphItem);
